import React from 'react';
import PropTypes from 'prop-types';
import SidebarNav from './SidebarNav';
import SidebarFooter from './SidebarFooter';

// <aside class="sidebar"> — бренд + навигация разделов + футер.
// На мобиле выезжает поверх контента; onNavigate закрывает drawer после выбора.
export default function Sidebar({ onNavigate }) {
    return (
        <aside className="sidebar">
            <div className="side-brand">
                <span className="logo">SOL Baumanec</span>
            </div>
            <SidebarNav onNavigate={onNavigate} />
            <SidebarFooter onNavigate={onNavigate} />
        </aside>
    );
}

Sidebar.propTypes = {
    onNavigate: PropTypes.func.isRequired
};
